import React, { useEffect, useState } from "react";
import { database } from '../../firebase';
import { ref, onValue } from "firebase/database";
import { getAuth, signOut } from "firebase/auth";
import "./ScannedData.css"; // Import the CSS file


const SelectedDataDisplay = ({ selectedData, isModalOpen, setIsModalOpen }) => {
  if (!selectedData) return null;

  return (
    <>
      <div id="selected-data-box">
        <h3>Selected Data</h3>
        <p><strong>QR Data:</strong> {selectedData.qrcodeData}</p>
        <p><strong>Latitude:</strong> {selectedData.coordinates.x}</p>
        <p><strong>Longitude:</strong> {selectedData.coordinates.y}</p>
        {selectedData.completeAddress && (
          <p>
            <strong>Complete Address:</strong>{" "}
            <a
              href={`https://www.google.com/maps/search/${encodeURIComponent(selectedData.completeAddress)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="map-link"
            >
              {selectedData.completeAddress}
            </a>
          </p>
        )}
      </div>

      {isModalOpen && selectedData.imageUrl && (
        <div id="modal-overlay">
          <div id="modal-content">
            <button onClick={() => setIsModalOpen(false)} id="close-modal-button">
              X
            </button>
            <h3 id="modal-title">Scanned Image</h3>
            <img src={selectedData.imageUrl} alt="Scanned" id="modal-image" />
          </div>
        </div>
      )}
    </>
  );
};


const ScannedData = ({ user, onStartScan }) => {
  const [scans, setScans] = useState([]);
  const [selectedData, setSelectedData] = useState(null); // State to store the clicked QR data
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility


useEffect(() => {
  const userPath = user.email.replace(".", "-");
  const scanRef = ref(database, `data/scans/${userPath}`);

  // Load cached data from localStorage
  const cachedData = localStorage.getItem(`scans_${userPath}`);
  if (cachedData) {
    setScans(JSON.parse(cachedData));
  }

  // Set up real-time listener to Firebase
  const unsubscribe = onValue(scanRef, (snapshot) => {
    if (snapshot.exists()) {
      const data = snapshot.val();
      const entries = Object.entries(data).map(([key, value]) => ({
        ...value,
        key,
      }));
      const sortedEntries = entries.sort((a, b) => b.timestamp - a.timestamp);
      setScans(sortedEntries);
      localStorage.setItem(`scans_${userPath}`, JSON.stringify(sortedEntries));
    } else {
      setScans([]);
      localStorage.removeItem(`scans_${userPath}`);
    }
  });

  // Cleanup listener on unmount
  return () => unsubscribe();
}, [user]);

  // Truncate the QR code to the first 10 characters
  const truncateQRCode = (data) => {
    try {
      return data.length > 10 ? data.slice(0, 10) + "..." : data;
    } catch (error) {
      console.error("Error in truncateQRCode: ", error);
      return ""; // Return an empty string if an error occurs
    }
  };

  // Truncate latitude and longitude for table view (using string slicing)
  const truncateCoordinates = (coordinate) => {
    const str = coordinate.toString();
    return str.substring(0, str.indexOf(".") + 3); // Keep 5 decimal places
  };

  const handleRowClick = (data) => {
    setSelectedData(data); // Set the clicked row data
  };

  const handleSignOut = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      window.location.reload();
    } catch (error) {
      console.error("Error signing out:", error.message);
    }
  };

return (
  <div>
    <h2 id="scanned-data-title">Scanned Data</h2>

    <div id="button-container">
      <button onClick={onStartScan} id="add-scan-button">
        Add Scan
      </button>
      <button onClick={handleSignOut} id="signout-button">
        Sign Out
      </button>
    </div>

    <div className="table-wrapper">
      <table id="scanned-data-table">
        <thead>
          <tr>
            <th className="sticky-header">QR Data</th>
            <th className="sticky-header">Lat</th>
            <th className="sticky-header">Lon</th>
            <th className="sticky-header">Date</th>
            <th className="sticky-header">Time</th>
            <th className="sticky-header">Image</th>
          </tr>
        </thead>
        <tbody>
          {scans.map((scan) => (
            <tr
              key={scan.key}
              className={`scanned-row ${
                selectedData?.key === scan.key ? "selected-row" : ""
              }`}
              onClick={() => handleRowClick(scan)}
            >
              <td className="scanned-cell">{truncateQRCode(scan.qrcodeData)}</td>
              <td className="scanned-cell">{truncateCoordinates(scan.coordinates.x)}</td>
              <td className="scanned-cell">{truncateCoordinates(scan.coordinates.y)}</td>
              <td className="scanned-cell">{new Date(scan.timestamp).toLocaleDateString()}</td>
              <td className="scanned-cell">{new Date(scan.timestamp).toLocaleTimeString()}</td>
              <td className="scanned-cell">
                {scan.imageUrl ? (
                  <button
                    className="view-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsModalOpen(true);
                      setSelectedData(scan);
                    }}
                  >
                    View
                  </button>
                ) : (
                  "No Image"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <SelectedDataDisplay
      selectedData={selectedData}
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
    />
  </div>
);

};

export default ScannedData;
